import React from 'react'
import { participantsStyle } from './style'

const AddedParticipants = ({ input, defaultParticipants }) => {
  const values = input.value === '' ? [...defaultParticipants] : input.value
  return (
    <div>
      <p>Participantes agregados: </p>
      <div className="participants">
        {values.length > 0 &&
          values.map((v, index) => (
            <p>
              {index + 1}.- {v.value}
            </p>
          ))}
      </div>
      <style jsx>{participantsStyle}</style>
    </div>
  )
}

export default AddedParticipants
